import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/care_link_client/care_link_client/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/care_link_client/care_link_client/src/components/ui/elements/index.ts");
